// src/components/layout/AdminRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useTenant } from "../../context/TenantContext";
import { LoadingSpinner } from "../ui";
import VerifyEmailGate from "./VerifyEmailGate";

export default function AdminRoute({ children }) {
  const { user, isAdmin, isSuperAdmin, superAdminChecked, loading } = useAuth();
  const { tenantLoading, tenantError } = useTenant();

  if (loading || !superAdminChecked || tenantLoading) return <LoadingSpinner />;
  if (!user)                         return <Navigate to="/login" replace />;
  if (!isAdmin && !isSuperAdmin)     return <Navigate to="/"     replace />;

  // Super admins can always access for impersonation, even if suspended
  if (!isSuperAdmin && tenantError === "suspended") {
    return (
      <div className="flex flex-col min-h-screen items-center justify-center bg-surface-50 text-center px-4">
        <div className="text-5xl mb-4">🚫</div>
        <h2 className="font-semibold text-2xl text-ink-900 mb-2">Account suspended</h2>
        <p className="text-ink-400 text-sm font-sans mb-6">
          Your account has been suspended. Please contact Bookyara support.
        </p>
      </div>
    );
  }

  return <VerifyEmailGate>{children}</VerifyEmailGate>;
}
